var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 186,
    viewBox: "0 0 185 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5499 0.650024C41.7299 0.650024 0.149902 42.23 0.149902 93.05C0.149902 143.87 41.7299 185.45 92.5499 185.45C143.37 185.45 184.95 143.87 184.95 93.05C184.95 42.23 143.37 0.650024 92.5499 0.650024ZM131.358 77.342L87.0059 121.694C83.3099 125.39 77.7659 125.39 74.0699 121.694L53.7419 101.366C50.0459 97.67 50.0459 92.126 53.7419 88.43C57.4379 84.734 62.9819 84.734 66.6779 88.43L80.5379 102.29L118.422 64.406C122.118 60.71 127.662 60.71 131.358 64.406C135.054 68.102 135.054 73.646 131.358 77.342Z",
    fill: "#1CD93C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckIcon);
export default __webpack_public_path__ + "static/media/green-check-icon.88ecb6701bde18b8aed49e7187a2d027.svg";
export { ForwardRef as ReactComponent };